<template>
  <div class="add-box">
    <TableLayout>
      <template slot="search-form">
        <section class="btn-actions">
          <div class="fl">
            <el-form class="dialog-search-form" ref="searchForm" slot="search-form" :model="searchForm" label-width="86px" inline>
              <el-form-item label="检查状态" prop="status">
                <el-select
                  v-model="searchForm.status"
                  placeholder="请选择"
                  >
                  <el-option v-for="(item,i) in checkStatus" :key="i" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="检查编号" prop="accessNo">
                <el-input v-model="searchForm.accessNo" size="medium" clearable class="item-width"></el-input>
              </el-form-item>
              <section  style="">
                <el-button
                  size="small"
                  type="primary"
                  @click="search()"
                >搜索</el-button>
              </section>
            </el-form>
          </div>
        </section>
      </template>
      <template slot="table-wrap">
        <el-table
          ref="tableList" :height="530"
          :header-cell-style="{background:'#1e87f1', color:'#fff'}"
          v-loading="isWorking.loading"  :row-key="getRowKey"
          :data="tableData.list" @selection-change="handleSelectionChange" :single-select="true"
        >
          <el-table-column type="selection" width="50" :selectable="selecteable" :reserve-selection="true" :label-class-name="'hidden'"></el-table-column>
          <el-table-column prop="accessNo" label="检查编号" min-width="150px" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="100px" align="center"></el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="previewDimage(row)">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="fix-footer">
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange($event, { msg: true })"
          :pagination="tableData.pagination"
        ></pagination>
        </div>
      </template>  
    </TableLayout>
  </div>
</template>

<script>
import TableLayout from '@/layout/TableLayout'
import BaseTable from '@/components/BaseTable'
import Pagination from '@/components/common/pagination'
import { fileServer } from '@/api/api'
export default {
  components: {TableLayout, Pagination},
  extends: BaseTable,
  props: ['studyData', 'detailInfo'],
  data () {
    return {
      checkStatus: [
        { name: '全部', id: null },
        { name: '未入库', id: 0 }
      ],
      searchForm: {
        status: 0,
        accessNo: ''
      }
    }
  },
  methods: {
    /**
     * 页码变更处理
     * @function handlePageChange
     * @param { Interger } pageIndex 搜索页面
     * @param { Object } obj 搜索处理逻辑内容
     */
    handlePageChange (pageIndex, obj = {}) {
      this.$refs.tableList.clearSelection();
      this.isWorking.loading = true
      this.tableData.pagination.pageIndex = pageIndex
      fileServer.getcheckData({
        ...this.searchForm,
        page: pageIndex,
        rows: this.tableData.pagination.pageSize
      }).then(res => {
        this.isWorking.loading = false
        let { code, data, message } = res
        if (code === '0') {
          if (data) {
            this.tableData.list = data.records
            this.tableData.pagination.total = data.total || 0
            this.loadSelectData()
          }
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.isWorking.loading = false
      })
    },
    loadSelectData () {
      if (this.studyData.length) {
        this.studyData.forEach(v => {
          this.$refs.tableList.toggleRowSelection(v, true)
        })
      }
    },
    previewDimage (row) {
      window.open(this.$dimage + row.url, '_blank')
    },
    select(selection, row){
        this.$refs.tableList.clearSelection()
        if (selection.length === 0) {
          return
        }
        this.$emit('updateStudyData', selection)
        this.$refs.tableList.toggleRowSelection(row, true)
    },
    handleSelectionChange (val) {
      console.log(val, 'vvv')
      this.$emit('updateStudyData', val)
    },
    selecteable (row, index) {
      if (row.status === 1) {
        if (this.detailInfo && this.detailInfo.studyUploadList) {
          const hasUuid = this.detailInfo.studyUploadList.some(obj => obj.studyUuid === row.studyUuid)
          if (hasUuid) {
            return true
          }
        }
        return false
      }
      return true
    },
    getRowKey (row) {
      return row.studyUuid
    }
  }
}
</script>

<style scoped lang='scss'>
.add-box {
  text-align: left;
}
/deep/.el-table th>.cell.hidden {
  visibility: hidden !important;
}
</style>
<style lang="scss" scoped>
.add-box .table-search-form .form-wrap {
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/SelectDicom.vue